import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';

import PageTitle from 'components/common/PageTitle';

const styles = () => ({
  root: {
    marginBottom: 16,
  },
});

const PatientAssignToolbar = ({ classes }) => (
  <Toolbar
    className={classes.root}
    disableGutters
  >
    <Grid
      container
      justify="space-between"
      alignItems="center"
      spacing={24}
    >
      <Grid item>
        <PageTitle
          text="Create order: Patient Assign"
          href="/workflow"
          variant="button"
        />
      </Grid>
    </Grid>
  </Toolbar>
);

PatientAssignToolbar.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(PatientAssignToolbar);



// WEBPACK FOOTER //
// ./src/components/workflow/PatientAssignToolbar/PatientAssignToolbar.js